import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { CustomZenithFormGroupErrorComponent } from '../custom-zenith-form-group-error/custom-zenith-form-group-error.component';
import { InvalidAsyncPipe } from '../../../../shared/pipes/invalid-async.pipe';
import { AsyncPipe } from '@angular/common';

/**
 * @deprecated Use the common `ZenithInputNumberComponent` instead.
 */
@Component({
  selector: 'zenith-numeric-input-form-group',
  templateUrl: './zenith-numeric-input-form-group.component.html',
  standalone: true,
  imports: [
    CustomZenithFormGroupErrorComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ZenithComponentsModule,
    InvalidAsyncPipe,
    AsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.Default // TODO Use OnPush once custom-zenith-form-group-error uses signals.
})
export class ZenithNumericInputFormGroup {
  readonly control = input.required<FormControl<number | null>>();
  readonly name = input.required<string>();
  readonly label = input.required<string>();
  readonly hint = input<string | null>(null);
  readonly showControls = input<boolean>(false);
  readonly step = input<number | null>(null);
  readonly suffix = input<string | null>(null);
  readonly autofocus = input<boolean>(false);
}
